import UploadForm from 'views/bulkUpload/components/UploadForm/UploadForm';
import { downloadUploadSummary, downloadUploadSummaryWithErrors } from '../../content/downloadUploadSummary';
import { SummarySubmitSection } from 'views/bulkUpload/UploadCatalog/components/SummarySubmitSection/SummarySubmitSection';

interface DownloadOrdersStep2Props {
  errors: string[];
  updatedRecords: number;
  totalRecords: number;
  templateUrl: string;
  handleBack: () => void;
}

const DownloadOrdersStep2 = ({
  errors,
  updatedRecords,
  totalRecords,
  templateUrl,
  handleBack
}: DownloadOrdersStep2Props) => {
  const renderUploadInfo = errors && errors.length > 0
    ? downloadUploadSummaryWithErrors(updatedRecords, totalRecords, templateUrl)
    : downloadUploadSummary(updatedRecords, totalRecords);

  return (
    <UploadForm
      uploadInfo={renderUploadInfo}
      confirmationModal={false}
      customSubmitSection={
        <SummarySubmitSection
          areErrors={errors && errors.length > 0}
          errorTemplateURL={templateUrl}
          handleReturnToUpload={handleBack}
          typeOfSummary='orders'
        />
      }
      hideAlert
      hideFileInput
      errors={errors}
    />
  );
};

export default DownloadOrdersStep2;
